/**
 * Painel "Filtros" do Cadastro de Suprimentos (redesign 2026-09-15).
 *
 * As oito dimensões de antes (`filtros.DIMENSOES`) continuam existindo —
 * só saíram da barra e entraram num slide-over, um `FiltroExcel` por
 * dimensão. A seleção aplica AO VIVO (contrato do FiltroExcel); o rodapé
 * mostra quantos itens passam e limpa tudo de uma vez.
 */
import React from "react";

import FiltroExcel from "../../../components/FiltroExcel";
import SlideOverPanel from "../../../components/SlideOverPanel";
import { Rotulo } from "../RequisicoesCompra/ui";
import { DIMENSOES } from "./filtros";

export default function FiltrosPanel({
  open, onClose, selecao, onChange, opcoes, totalFiltrado, totalGeral, onLimpar,
}) {
  const ativos = DIMENSOES.filter((d) => selecao[d.key]).length;
  const footer = (
    <div style={{ display: "flex", gap: 8, alignItems: "center", justifyContent: "space-between" }}>
      <span style={{ fontSize: 12.5, color: "var(--ink-3)" }}>
        <b style={{ color: "var(--ink)" }}>{totalFiltrado}</b> de {totalGeral} passam
      </span>
      <div style={{ display: "flex", gap: 8 }}>
        <button type="button" className="btn btn--secondary" onClick={onLimpar} disabled={!ativos}>Limpar</button>
        <button type="button" className="btn btn--primary" onClick={onClose}>Fechar</button>
      </div>
    </div>
  );

  return (
    <SlideOverPanel
      open={open}
      onClose={onClose}
      title="Filtros"
      subtitle="Cada dimensão funciona como o filtro do Excel: marque os valores que quer ver."
      footer={footer}
      width="min(94vw, 420px)"
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        {DIMENSOES.map((d) => (
          <div key={d.key}>
            <Rotulo>{d.rotulo}</Rotulo>
            <FiltroExcel
              rotulo={d.rotulo}
              opcoes={opcoes[d.key] || []}
              selecionadas={selecao[d.key]}
              onChange={(v) => onChange(d.key, v)}
            />
          </div>
        ))}
      </div>
    </SlideOverPanel>
  );
}
